import React, { useEffect } from 'react';

interface CrispChatProps {
  websiteId: string;
}

const CrispChat: React.FC<CrispChatProps> = ({ websiteId }) => {
  useEffect(() => {
    // Initialisation de Crisp
    window.$crisp = [];
    window.CRISP_WEBSITE_ID = websiteId;

    // Chargement du script Crisp
    (function() {
      const d = document;
      const s = d.createElement('script');
      s.src = 'https://client.crisp.chat/l.js';
      s.async = true;
      d.getElementsByTagName('head')[0].appendChild(s);
    })();

    // Nettoyage lors du démontage du composant
    return () => {
      // Suppression du script et réinitialisation des variables
      const scriptElement = document.querySelector('script[src="https://client.crisp.chat/l.js"]');
      if (scriptElement) {
        scriptElement.remove();
      }
      // Réinitialisation des variables Crisp
      if (window.CRISP_WEBSITE_ID) {
        window.CRISP_WEBSITE_ID = '';
      }
      if (window.$crisp) {
        window.$crisp = [];
      }
    };
  }, [websiteId]);

  return null; // Ce composant n'a pas de rendu visuel
};

export default CrispChat;

// Déclaration pour TypeScript
declare global {
  interface Window {
    $crisp: any[];
    CRISP_WEBSITE_ID: string;
  }
}
